import { get } from '@fable/api'
import { Loader } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { Book, Review } from '@fable/types'
import { useQuery } from 'react-query'
import { BookDetailReview } from './BookDetailReview'

interface Props {
  book: Book | undefined
  mini: boolean
}

export const BookDetailReviewsPreview = ({ book, mini }: Props) => {
  const { colors } = useTheme()
  const { data, isLoading } = useQuery(
    ['reviews-preview'],
    () => get(`/books/${book?.id}/reviews/?limit=5`),
    { enabled: !!book?.id }
  )

  if (isLoading) return <Loader />

  const list = data?.data?.results || []

  if (!list.length) return null

  return (
    <div
      className={cx(
        css`
          margin-top: 24px;
        `,
        'fade'
      )}
    >
      {list?.map((review: Review) => (
        <div
          key={review.id}
          className={css`
            &:not(:last-child) {
              margin-bottom: 12px;
              padding-bottom: 24px;
              border-bottom: 1px solid ${colors.whiteSmoke};
            }
          `}
        >
          <BookDetailReview review={review} mini={mini} />
        </div>
      ))}
    </div>
  )
}
